import template from './form.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import sucursalesI18N from 'i18n/sucursales/es.json';
import commonI18N from 'i18n/common/es.json';
import { pad } from 'core/util';
import { formatErrorMessage } from 'core/util';

export let SucursalFormComponent = {
  templateUrl: template,
  selector: 'sucursalForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};


export const translationKeys = Object.keys(sucursalesI18N).concat(Object.keys(commonI18N));

FormController.$inject = ['$state', '$ngRedux', 'ngNotify', '$stateParams', '$timeout', '$scope'];

function FormController($state, $ngRedux, ngNotify, $stateParams, $timeout, $scope) {
  this.cancel = cancel.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.handleErrors = handleErrors.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);

  this.newDetalle = newDetalle.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);
  this.renderDescripcion = renderDescripcion.bind(this);

  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver sucursal'] : this.translations['Editar sucursal'];
      this.formEdit('sucursales', $stateParams.uid);
    } else {
      this.title = this.translations['Nueva sucursal'];
      this.form();
    }
    $ngRedux.dispatch(rest.actions.paises.get());
    $ngRedux.dispatch(rest.actions.ciudades.get());
  };

  function mapStateToThis(state) {
    this.handleErrors(state);
    this.model = state.form.model;

    if (!this.model.detalles) {
      this.model.detalles = [];
    } else {
      this.model.detalles = this.model.detalles.sort(function(a, b) { return a.codigo > b.codigo; });
    }

    this.listadoPaises = state.paises.data;
    this.listadoCiudades = state.ciudades.data;
    this.submitted = state.form.flags ? state.form.flags.submitted : false;

    return { form: state.form, paises: state.paises, ciudades: state.ciudades };
  }

  /**
   * Función que se encarga de mostrar mensajes de error en base al estado actual
   * 
   * @param {object} state
   */
  function handleErrors(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.sucursales.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.paises.error) {
      ngNotify.set(state.paises.error.message, 'error');
    }

    if (state.ciudades.error) {
      ngNotify.set(state.ciudades.error.message, 'error');
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.sucursales.list');
    }
  }

  /**
   * Cancela el formulario y retorna al listado
   */
  function cancel() {
    $state.go('home.sucursales.list');
  }

  function doSubmit() {
    if ($scope.sucursalForm.$invalid) {
      this.submitted = true;
      return;
    }

    let codigoRepetido = false;
    this.model.detalles.forEach(function(elementI, indexI, array) {
      array.forEach(function(elemenJ, indexJ) {
        if (indexJ !== indexI && elemenJ.codigo === elementI.codigo) {
          codigoRepetido = true;
        }
      });
    });
    if (codigoRepetido) {
      ngNotify.set(this.translations['No pueden existir codigos repetidos'], 'warn');
      return;
    }

    var data = Object.assign({}, this.model);
    this.save('sucursales', data);
  }

  function newDetalle() {
    let detalle = {};
    let last = this.model.detalles[this.model.detalles.length - 1];
    if (last) {
      detalle.codigo = last.codigo + 1;
    } else {
      detalle.codigo = 1;
    }
    this.renderDescripcion(detalle);
    this.model.detalles.push(detalle);
  }

  function deleteDetalle(detalle) {
    _.remove(this.model.detalles, detalle);
  }

  function renderDescripcion(detalle) {
    let codigoSucursal = this.model.codigo ? this.model.codigo : 0;
    let codigoDetalle = detalle.codigo ? detalle.codigo : 0;
    detalle.descripcion = `Sucursal: ${pad(codigoSucursal, 3)} - ${this.model.nombre}, Punto de emisión: ${pad(codigoDetalle, 3)}`;
  }

  this.onChangeCodigo = onChangeCodigo.bind(this);

  function onChangeCodigo() {
    this.model.detalles.forEach((detalle) => {
      this.renderDescripcion(detalle);
    });
  }
}


// WEBPACK FOOTER //
// ./src/components/sucursales/form/form.component.js